// extracted by mini-css-extract-plugin
export default {"TableauBootstrap":"ModifierComposante_TableauBootstrap__EuHId","btn_stylo":"ModifierComposante_btn_stylo__coLVG","center":"ModifierComposante_center__ZQIqw"};